"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var EventSubscription =
/*#__PURE__*/
function () {
  function EventSubscription(emitter, event, listener) {
    _classCallCheck(this, EventSubscription);

    this.emitter = emitter;
    this.event = event;
    this.listener = listener;
  }

  _createClass(EventSubscription, [{
    key: "remove",
    value: function remove() {
      this.emitter.removeSubscription(this);
    }
  }]);

  return EventSubscription;
}();

exports.EventSubscription = EventSubscription;

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.eventSubscriptions = new Map();
  }

  _createClass(EventEmitter, [{
    key: "addListener",
    value: function addListener(event, listener) {
      var sub = new EventSubscription(this, event, listener);
      sub.prev = null;
      sub.next = null;

      if (this.eventSubscriptions.has(event)) {
        var head = this.eventSubscriptions.get(event);

        if (head.first == null) {
          head.first = sub;
          head.last = sub;
        } else {
          head.last.next = sub;
          sub.prev = head.last;
          head.last = sub;
        }
      } else {
        this.eventSubscriptions.set(event, {
          first: sub,
          last: sub
        });
      }

      return sub;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      if (this.eventSubscriptions.has(event)) {
        var p = this.eventSubscriptions.get(event).first;

        for (var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          parameters[_key - 1] = arguments[_key];
        }

        while (p) {
          var _p;

          (_p = p).listener.apply(_p, parameters);

          p = p.next;
        }
      }
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(subscription) {
      var head = this.eventSubscriptions.get(subscription.event);

      if (subscription.prev != null) {
        subscription.prev.next = subscription.next;
      } else {
        head.first = subscription.next;
      }

      if (subscription.next != null) {
        subscription.next.prev = subscription.prev;
      } else {
        head.last = subscription.prev;
      }
    }
  }]);

  return EventEmitter;
}();

exports.EventEmitter = EventEmitter;

function compareOrder(a, b) {
  if (a[0] == b[0]) {
    return a[1] - b[1];
  } else {
    return a[0] - b[0];
  }
}

var Dispatcher =
/*#__PURE__*/
function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this.registeredItems = new Map();
    this.currentID = 0;
    this.isDispatching = false;
    this.dispatchingIndex = 0;
  }

  _createClass(Dispatcher, [{
    key: "dispatch",
    value: function dispatch(action) {
      if (this.isDispatching) {
        throw new Error("Dispatcher: cannot dispatch in the middle of a dispatch");
      }

      this.isDispatching = true;
      this.dispatchingIndex = 0;
      this.currentAction = action;
      this.registeredItems.forEach(function (x) {
        return x.stage = 0;
      });

      try {
        // Order the items by order of registration
        var items = Array.from(this.registeredItems.values());
        items = items.sort(function (a, b) {
          return compareOrder(a.order, b.order);
        }); // Dispatch in the order

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.stage != 0) {
              continue;
            }

            this.invoke(item);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } finally {
        delete this.currentAction;
        this.isDispatching = false;
      }
    }
  }, {
    key: "invoke",
    value: function invoke(item) {
      item.stage = 1;
      item.callback(this.currentAction);
      this.dispatchingIndex += 1;
      item.stage = 2;
    }
  }, {
    key: "register",
    value: function register(callback) {
      var priority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Dispatcher.PRIORITY_DEFAULT;
      var id = "ID" + (this.currentID++).toString();
      this.registeredItems.set(id, {
        order: [priority, this.currentID],
        stage: 0,
        callback: callback
      });
      return id;
    }
  }, {
    key: "unregister",
    value: function unregister(id) {
      this.registeredItems.delete(id);
    }
  }, {
    key: "waitFor",
    value: function waitFor(ids) {
      var _this = this;

      ids = ids.filter(function (a) {
        return _this.registeredItems.has(a);
      }).sort(function (a, b) {
        return compareOrder(_this.registeredItems.get(a).order, _this.registeredItems.get(b).order);
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = ids[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var id = _step2.value;
          var item = this.registeredItems.get(id);

          if (item.stage == 1) {
            console.warn("Dispatcher: circular dependency detected in waitFor " + id);
            continue;
          } else if (item.stage == 2) {
            continue;
          }

          this.invoke(item);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }]);

  return Dispatcher;
}();

Dispatcher.PRIORITY_LOW = 70;
Dispatcher.PRIORITY_DEFAULT = 50;
Dispatcher.PRIORITY_HIGH = 30;
exports.Dispatcher = Dispatcher;